import React, { createContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { CRICKET_API_URL } from "../config"; // ✅ CORRECT URL IMPORT

export const MatchContext = createContext();

// Helper for Colors (Jo tumhare Home.jsx me tha)
const getRandomColor = () => {
    const colors = ["#1e3c72", "#2a5298", "#d32f2f", "#388e3c", "#fbc02d", "#512da8"];
    return colors[Math.floor(Math.random() * colors.length)];
};

export const MatchProvider = ({ children }) => {
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const [liveScores, setLiveScores] = useState({});
    const [loading, setLoading] = useState(true);

    // --- 1. FETCH SCHEDULED MATCHES ---
    const fetchUpcomingMatches = useCallback(async () => {
        
        try {
            const today = new Date().toISOString().split('T')[0];

            // ✅ FIX: Correct API URL use kiya
            const res = await axios.get(`${CRICKET_API_URL}/api/cricket/matches/${today}`);

            // ✅ LOGIC FIX: Data ko wahi format diya jo Home.jsx expect kar raha hai
            const rawData = res.data.data || res.data || []; // API response handle

            if (Array.isArray(rawData)) {
                const formattedMatches = rawData.map(match => {
                    const normalizedStatus = String(match.status || "").toLowerCase();
                    const hasLineupSignal =
                        Boolean(match.lineupOut ?? match.lineupsOut) ||
                        normalizedStatus === "lineup_out" ||
                        normalizedStatus === "live";

                    return {
                        matchId: match.id,
                        matchType: match.tournament,
                        seriesName: match.seriesName || match.tournament,
                        matchStartTime: match.matchStartTime || match.startTime,
                        startTime: match.startTime || match.matchStartTime,
                        status: normalizedStatus,
                        isLive: normalizedStatus === "live",
                        lineupOut: hasLineupSignal,
                        lineupsOut: hasLineupSignal,

                        // Team 1
                        team1: {
                            name: match.homeTeam?.name || "Team 1",
                            code: match.homeTeam?.code || (match.homeTeam?.name?.slice(0, 3).toUpperCase()),
                            image: match.homeTeam?.logo || null,
                            color: getRandomColor()
                        },

                        // Team 2
                        team2: {
                            name: match.awayTeam?.name || "Team 2",
                            code: match.awayTeam?.code || (match.awayTeam?.name?.slice(0, 3).toUpperCase()),
                            image: match.awayTeam?.logo || null,
                            color: getRandomColor()
                        }
                    };
                });

                setUpcomingMatches(formattedMatches);
            }

        } catch (error) {
            console.error("Error fetching matches:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    // --- 2. FETCH LIVE SCORE ---
    const fetchLiveScore = useCallback(async (matchId) => {
        if (!matchId) return;
        try {
            const res = await axios.get(`${CRICKET_API_URL}/api/cricket/match/${matchId}/live`);
            if (res.data) {
                setLiveScores(prev => ({ ...prev, [matchId]: res.data }));
            }
        } catch (error) {
            console.error(`Live Score Error ${matchId}:`, error);
        }
    }, []);

    // --- 3. INITIAL LOAD ---
    useEffect(() => {
        fetchUpcomingMatches();
        const interval = setInterval(fetchUpcomingMatches, 60000); // 1 min refresh
        return () => clearInterval(interval);
    }, [fetchUpcomingMatches]);

    return (
        <MatchContext.Provider value={{
            upcomingMatches,
            liveScores,
            loading,
            fetchUpcomingMatches,
            fetchLiveScore
        }}>
            {children}
        </MatchContext.Provider>
    );
};
